exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style__card___3O-vZ {\n  margin: 10px;\n  background: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);\n  width: 100%; }\n  .style__card___3O-vZ .style__image___2-Zma img {\n    max-width: 100%;\n    border-top-left-radius: 5px;\n    border-top-right-radius: 5px; }\n  .style__card___3O-vZ .style__content___1ctCH {\n    padding: 20px 30px; }\n\n.style__isLoading___1XPSt .style__image___2-Zma {\n  background: #eee;\n  background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);\n  border-radius: 5px;\n  background-size: 200% 100%;\n  animation: style__shine___2sw7G 1.5s linear infinite; }\n\n.style__isLoading___1XPSt .style__image___2-Zma {\n  height: 100%; }\n\n@keyframes style__shine___2sw7G {\n  to {\n    background-position-x: -200%; } }\n", ""]);

// exports
exports.locals = {
	"card": "style__card___3O-vZ",
	"image": "style__image___2-Zma",
	"content": "style__content___1ctCH",
	"isLoading": "style__isLoading___1XPSt",
	"shine": "style__shine___2sw7G"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/Skeleton/style.scss
// module id = 4232
// module chunks = 6